import ReleaseNotesByod from '@src/main/modules/parameters/ui/release-notes-byod/components/ReleaseNotesByod';

const ReleaseNotesByodPage = () => <ReleaseNotesByod />;

export default ReleaseNotesByodPage;
